import React from 'react'
import { Grid, Button, Typography, CircularProgress } from '@material-ui/core'
import { TextField } from 'elentari'
import { Field, Form } from 'react-final-form'
import UploadField from '../../components/UploadField'
import documentosRepository from './DocumentosRepository'

const MAX_IMAGE_SIZE = 1000000 * 15
const MAX_FILE_SIZE = 1000000 * 25

let localIdCounter = 0

const getFileSizeError = file => {
  const isImage =
    /^image\//.test(file.type || '') || /\.(jpe?g|png)$/i.test(file.name || '')
  if (file.size > (isImage ? MAX_IMAGE_SIZE : MAX_FILE_SIZE)) {
    return isImage
      ? 'Imagem muito grande. O tamanho máximo é 15 MB.'
      : 'Arquivo muito grande. O tamanho máximo é 25 MB.'
  }
}

const DocumentosForm = ({
  match,
  onGoBack,
  documentosLocais = [],
  onChangeDocumentosLocais,
  cannotUpdate
}) => {
  const localMode = !!onChangeDocumentosLocais
  const bloqueado = localMode && !!cannotUpdate

  const validateFile = file => {
    if (!file) return 'Obrigatório'
    if (localMode) return getFileSizeError(file)
  }

  const validate = data => {
    return {
      descricao:
        data.descricao && data.descricao.trim() ? undefined : 'Obrigatório',
      file: validateFile(data.file)
    }
  }

  const handleSubmit = async data => {
    if (localMode) {
      localIdCounter += 1
      onChangeDocumentosLocais([
        ...documentosLocais,
        {
          id: `local-${Date.now()}-${localIdCounter}`,
          descricao: data.descricao,
          fileName: data.file.name,
          file: data.file
        }
      ])
      onGoBack && onGoBack()
      return
    }

    const dataCopy = {
      descricao: data.descricao,
      fileName: data.file.name
    }

    const response = await documentosRepository.uploadDocumento(
      match.params.id,
      dataCopy,
      data.file
    )
    if (response.ok) {
      onGoBack && onGoBack()
    }
  }

  return (
    <Grid container alignItems="center" spacing={3}>
      <Grid item sm={12} xs={12}>
        <Typography variant="h6" gutterBottom>
          Adicionar Documento
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Form onSubmit={handleSubmit} validate={validate}>
          {({ handleSubmit, submitting, values, errors }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item sm={6} xs={12}>
                  <Field
                    name="descricao"
                    label="Descrição"
                    fullWidth
                    component={TextField}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Field
                    accept=".jpg,.jpeg,.png,.pdf"
                    component={UploadField}
                    label="Arquivo"
                    name="file"
                  />
                  {localMode && values.file && errors.file && (
                    <Typography variant="caption" color="error" display="block">
                      {errors.file}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="baseline"
                    spacing={2}
                  >
                    <Grid item>
                      <Button
                        fullWidth
                        onClick={onGoBack}
                        disabled={submitting || bloqueado}
                        variant="outlined"
                      >
                        Voltar
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        fullWidth
                        type="submit"
                        disabled={submitting || bloqueado}
                        variant="contained"
                        color="primary"
                      >
                        {submitting && <CircularProgress size={24} />}
                        {localMode ? 'Adicionar' : 'Enviar'}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          )}
        </Form>
      </Grid>
    </Grid>
  )
}
export default React.memo(DocumentosForm)
